// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav_style {
  color: #000000;
  font-weight: 300 !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 150ms;
  margin: 0px 1rem;
  display: inline-block;
  position: relative; }

.nav_style_mobile {
  color: #ffffff;
  font-weight: 300 !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 150ms;
  margin: 0.5rem 0rem;
  display: inline-block;
  position: relative; }

.nav_style:hover {
  color: #1F43DB; }

.nav-bar-floated {
  background: rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px); }
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/styles.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,2BAA2B;EAC3B,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,0BAAM;EACN,wDAAM;EACN,uBAAM;EACN,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,2BAA2B;EAC3B,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,0BAAM;EACN,wDAAM;EACN,uBAAM;EACN,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB,EAAA;;AAGpB;EACE,cAAc,EAAA;;AAGhB;EACE,oCAAoC;EACpC,kCAA0B;UAA1B,0BAA0B,EAAA","sourcesContent":[".nav_style {\n  color: #000000;\n  font-weight: 300 !important;\n  @apply transition;\n  @apply ease-in-out;\n  @apply delay-150;\n  margin: 0px 1rem;\n  display: inline-block;\n  position: relative;\n}\n\n.nav_style_mobile {\n  color: #ffffff;\n  font-weight: 300 !important;\n  @apply transition;\n  @apply ease-in-out;\n  @apply delay-150;\n  margin: 0.5rem 0rem;\n  display: inline-block;\n  position: relative;\n}\n\n.nav_style:hover {\n  color: #1F43DB;\n}\n\n.nav-bar-floated {\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(6px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
